import { Injectable } from "@angular/core";
import { Batch, BatchStatus } from "./batch.model";
import { Observable, of, tap } from "rxjs";
import { BatchApiService } from "./batch-api.service";
import { AuthManagerService } from "../auth/auth-manager.service";
import { PagingResponse } from "../vendor/models/vendor-for-new-po.model";
import { PagingRequest } from "src/app/shared-api/models/paging.model";

@Injectable({
    providedIn: 'root'
})
export class BatchManagerService {
    constructor(private batchApiService: BatchApiService, private authManager: AuthManagerService){}

    getBatchesForLocation(locationId: number, options?: PagingRequest): Observable<PagingResponse<Batch>> {
        return this.batchApiService.getBatchesForLocation(locationId, options)
    }
    getBatchesForSubsidiary(subsidiaryId: number, options?: PagingRequest): Observable<PagingResponse<Batch>> {
        return this.batchApiService.getBatchesForSubsidiary(subsidiaryId, options)
    }
    getAllBatches(options?: PagingRequest): Observable<PagingResponse<Batch>> {
        return this.batchApiService.getAllBatches(options);
    }
    deleteBatch(id: number): Observable<any> {
        return this.batchApiService.deleteBatch(id);
    }
    
    addBatch(batch: Batch): Observable<Batch> {
        return this.batchApiService.addBatch(batch);
    }

    updateBatch(batch: Batch): Observable<Batch> {
        return this.batchApiService.updateBatch(batch);
    }
}